import React, { useMemo } from "react";
import KC_Card_Dashed from "../../../../designsystem/KC_Card/KC_Card_Dashed";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Card from "../../../../designsystem/KC_Card/KC_Card";
import GameCardPreview from "../../../23_GameCardPreview/GameCardPreview";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import TSUtils from "../../../../utils/helpers/TSUtils";
import { useEventsSelector } from "../../../../redux/actions/wheel";
import { getEventName } from "./EventSection";
import { ActiveEvent } from "kadow-jetpack-model";
import CardsContainerFlex from "../../../../components/CardsContainer/CardsContainerFlex";
import {
  updateJetpackConfigThunk,
  useJetpackConfigSelector
} from "../../../../redux/jetpackConfig";
import { useDispatch } from "react-redux";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import { SUGGESTED_EVENTS_LIST } from "../../../../utils/constants";
import KC_Icon_Button from "../../../../designsystem/KC_Button/KC_Icon_Button";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { KC_ButtonSize } from "../../../../designsystem/KC_Button/KC_Button";
import { tt } from "../../../../utils/i18n/i18n";

export default function EventSuggestion() {
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const jetpackConfig = useJetpackConfigSelector();
  const events = useEventsSelector();

  const FILTERED_SUGGEST_EVENT_LIST = useMemo(() => {
    if (jetpackConfig?.dml) {
      return [];
    }
    return filterSuggestedEvents(
      SUGGESTED_EVENTS_LIST,
      jetpackConfig?.activeEvents || []
    );
  }, [jetpackConfig?.dml, jetpackConfig?.activeEvents]);

  const handleSave = (event: ActiveEvent) => {
    const newActiveEvent = [...(jetpackConfig?.activeEvents || []), event];
    dispatch(
      updateJetpackConfigThunk(
        { activeEvents: newActiveEvent },
        accountToDisplay?.trackingID,
        accountToDisplay?.token
      )
    );
  };

  if (!FILTERED_SUGGEST_EVENT_LIST?.length) {
    return null;
  }

  return (
    <KC_Card_Dashed isHighlight={true} onClick={() => {}}>
      <KC_Heading2
        text={tt("discover_highlights_ideas")}
        className="w-100 text-left text-blue"
      />
      <CardsContainerFlex>
        {FILTERED_SUGGEST_EVENT_LIST?.map((event, idx) => {
          if (!event.gameType) {
            return null;
          }

          const eventConfig = events?.find((e) => e._id === event.id);

          if (!eventConfig) {
            return null;
          }

          const skin = eventConfig.skins.find((s) => s.game === event.gameType);

          if (!skin) {
            return null;
          }

          return (
            <KC_Card
              key={`${event.id}-${idx}`}
              title={getEventName(eventConfig, event.gameType)}
              boxShadow={false}
              description=""
              useTwicPics={true}
              isGameCardPreview={true}
              className="border"
              canDelete
              onClick={() => handleSave(event)}
              handleDelete={() => {}}
              children={
                <>
                  <div className="w-100 text-center">
                    <KC_UIText
                      weight={"reg"}
                      text={
                        <div className="d-flex align-items-center">
                          <KC_Icon_Button
                            type={"button"}
                            isInverted={true}
                            size={KC_ButtonSize.Medium}
                            icon={faCalendarAlt}
                          />
                          <KC_UIText
                            weight={"bold"}
                            text={tt("highlight_date", {
                              startDate: TSUtils.formatDate(event.sts),
                              endDate: TSUtils.formatDate(event.ets)
                            })}
                          />
                        </div>
                      }
                    />
                  </div>
                  <GameCardPreview
                    gameCardConfig={skin.gameCardConfig}
                    eventId={event.id}
                  />
                </>
              }
            />
          );
        })}
      </CardsContainerFlex>
    </KC_Card_Dashed>
  );
}

function filterSuggestedEvents(
  suggestedEvents: ActiveEvent[],
  mainActiveEvents: ActiveEvent[]
): ActiveEvent[] {
  return suggestedEvents.filter((suggested) => {
    return !mainActiveEvents.some(
      (main) =>
        main.id === suggested.id &&
        main.gameType === suggested.gameType &&
        main.sts <= suggested.sts &&
        main.ets >= suggested.ets
    );
  });
}
